export const METHODS = {
  DEBUG: 'debug',
  LOG: 'log',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
  FATAL: 'fatal',
  CRITICAL: 'critical',
  API: 'api',
} as const;

export const LOG_LEVELS = METHODS;

export const DEFAULT_LOG_LEVEL = LOG_LEVELS.FATAL;

export const LOG_LEVELS_MAP = {
  [METHODS.DEBUG]: [
    METHODS.DEBUG,
    METHODS.LOG,
    METHODS.INFO,
    METHODS.WARN,
    METHODS.ERROR,
    METHODS.FATAL,
    METHODS.CRITICAL,
    METHODS.API,
  ],
  [METHODS.LOG]: [METHODS.LOG, METHODS.INFO, METHODS.WARN, METHODS.ERROR, METHODS.FATAL, METHODS.CRITICAL, METHODS.API],
  [METHODS.INFO]: [METHODS.INFO, METHODS.WARN, METHODS.ERROR, METHODS.FATAL, METHODS.CRITICAL, METHODS.API],
  [METHODS.WARN]: [METHODS.WARN, METHODS.ERROR, METHODS.FATAL, METHODS.CRITICAL, METHODS.API],
  [METHODS.ERROR]: [METHODS.ERROR, METHODS.FATAL, METHODS.CRITICAL, METHODS.API],
  [METHODS.FATAL]: [METHODS.FATAL, METHODS.CRITICAL, METHODS.API],
  [METHODS.CRITICAL]: [METHODS.CRITICAL, METHODS.API],
  [METHODS.API]: [METHODS.API],
};
